import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthPageTopLocationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 17.6152,
		cy: 17.4729,
		r: 16.6318,
		fill: "#33D4CF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.7848 5.61647L28.7993 24.6941H6.77035L17.7848 5.61647Z",
		fill: "#076A80"
	})]
});
export default SvgAuthPageTopLocationIcon;
